import { RouteName } from "../RouteNames";

export const PRMRoutes = [
  {
    name: RouteName.PRMNationalRoot,
    path: "prm-national",
    component: () => import("@follaw-fr/views/side_menu_views/PrmView.vue"),
    children: [
      {
        name: RouteName.PRMNational,
        path: "",
        component: () =>
          import("@follaw-fr/components/prm/organisms/PrmDatas.vue"),
      },
      {
        path: "activities",
        redirect: { name: RouteName.PRMNationalRoot },
      },
      {
        path: "news",
        redirect: { name: RouteName.PRMNationalRoot },
      },
      {
        name: RouteName.PRMNationalFollawedRoot,
        path: "follawed",
        children: [
          {
            name: RouteName.PRMNationalFollawed,
            path: "",
            component: () =>
              import("@follaw-fr/components/prm/organisms/PrmDatas.vue"),
          },
          {
            name: RouteName.PRMNationalFollawedNews,
            path: "news",
            component: () => import("@follaw-fr/views/prm/PrmNews.vue"),
          },
          {
            name: RouteName.PRMNationalFollawedActivity,
            path: "activities",
            component: () => import("@follaw-fr/views/prm/PrmActivities.vue"),
          },
        ],
      },
    ],
  },
  {
    name: RouteName.PRMNationalZoomRoot,
    path: "prm-national/:_id",
    component: () => import("@follaw-fr/views/side_menu_views/PrmZoomView.vue"),
    children: [
      {
        name: RouteName.PRMNationalZoomGeneralInfo,
        path: "",
        component: () => import("@follaw-fr/views/prm/PrmZoomCharts.vue"),
      },
      {
        name: RouteName.PRMNationalZoomBiography,
        path: "biography",
        component: () => import("@follaw-fr/views/prm/PrmZoomBio.vue"),
      },
      {
        name: RouteName.PRMNationalZoomNews,
        path: "news",
        component: () => import("@follaw-fr/views/prm/PrmNews.vue"),
      },
      {
        name: RouteName.PRMNationalZoomActivity,
        path: "activities",
        component: () => import("@follaw-fr/views/prm/PrmActivities.vue"),
      },
      {
        name: RouteName.PRMNationalZoomContact,
        path: "contact",
        component: () => import("@follaw-fr/views/prm/PrmZoomContact.vue"),
      },
      {
        name: RouteName.PRMNationalZoomQuestion,
        path: "question/:questionId",
        component: () =>
          import("@follaw-fr/views/side_menu_views/PrmQuestionZoomView.vue"),
      },
      {
        name: RouteName.PRMNationalZoomAmendment,
        path: "amendment/:amId",
        component: () =>
          import("@follaw-fr/views/side_menu_views/PrmAmendmentZoomView.vue"),
      },
    ],
  },

  {
    name: RouteName.PRMRegionalRoot,
    path: "prm-regional",
    component: () => import("@follaw-fr/views/side_menu_views/PrmView.vue"),
    children: [
      {
        name: RouteName.PRMRegional,
        path: "",
        component: () =>
          import("@follaw-fr/components/prm/organisms/PrmDatas.vue"),
      },
      {
        name: RouteName.PRMRegionalFollawedRoot,
        path: "follawed",
        children: [
          {
            path: "",
            name: RouteName.PRMRegionalFollawed,
            component: () =>
              import("@follaw-fr/components/prm/organisms/PrmDatas.vue"),
          },
          {
            name: RouteName.PRMRegionalFollawedNews,
            path: "news",
            component: () => import("@follaw-fr/views/prm/PrmNews.vue"),
          },
          {
            name: RouteName.PRMRegionalFollawedActivity,
            path: "activities",
            component: () => import("@follaw-fr/views/prm/PrmActivities.vue"),
          },
        ],
      },
    ],
  },

  {
    name: RouteName.PRMRegionalZoomRoot,
    path: "prm-regional/:_id",
    component: () => import("@follaw-fr/views/side_menu_views/PrmZoomView.vue"),
    children: [
      {
        name: RouteName.PRMRegionalZoomGeneralInfo,
        path: "",
        component: () => import("@follaw-fr/views/prm/PrmZoomCharts.vue"),
      },
      {
        name: RouteName.PRMRegionalZoomBiography,
        path: "biography",
        component: () => import("@follaw-fr/views/prm/PrmZoomBio.vue"),
      },
      {
        name: RouteName.PRMRegionalZoomNews,
        path: "news",
        component: () => import("@follaw-fr/views/prm/PrmNews.vue"),
      },
      {
        name: RouteName.PRMRegionalZoomActivity,
        path: "activities",
        component: () => import("@follaw-fr/views/prm/PrmActivities.vue"),
      },
      {
        name: RouteName.PRMRegionalContact,
        path: "contact",
        component: () => import("@follaw-fr/views/prm/PrmZoomContact.vue"),
      },
    ],
  },
];
